import { render, staticRenderFns } from "./Memory.vue?vue&type=template&id=73f73170&scoped=true"
import script from "./Memory.vue?vue&type=script&lang=js"
export * from "./Memory.vue?vue&type=script&lang=js"
import style0 from "./Memory.vue?vue&type=style&index=0&id=73f73170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f73170",
  null
  
)

export default component.exports